import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isAuthenticated: state => state.auth.isAuthenticated
    })
  },
  watch: {
    $route() {
      this.routeGuardInit()
    }
  },
  data: function() {
    return {
      routeGuardLoading: false
    }
  },
  methods: {
    ...mapActions({
      getAuthenticatedUser: 'auth/getAuthenticatedUser'
    }),
    ...mapGetters({
      getNeededVerification: 'auth/getNeededVerification',
      isVerified: 'auth/isVerified',
      isIdVerified: 'auth/isIdVerified',
      isPayoutEnabled: 'auth/isPayoutEnabled'
    }),

    /**
     * Handle auth redirection for all routes
     *
     * !@NOTE: For checkers that need the latest user data, add in also
     * either the `requireAuth` or `mayRequireAuth` depending on need
     */
    async routeGuardInit() {
      if (this.routeGuardLoading) return
      this.routeGuardLoading = true

      /* ...pages that may require authenticated users */
      if (this.$route.matched.some(route => route.meta.mayRequireAuth)) {
        await this.getAuthenticatedUser(true)
      }

      /* ...pages that requires authenticated users */
      if (this.$route.matched.some(route => route.meta.requiresAuth)) {
        await this.getAuthenticatedUser()
      }

      /* ...pages that requires non-authenticated users */
      if (this.$route.matched.some(route => route.meta.requiresNotAuth)) {
        if (this.isAuthenticated) {
          this.$router.replace({ name: 'home' })
        }
      }

      /* ...pages that requires fully verified users */
      if (this.$route.matched.some(route => route.meta.requiresVerified)) {
        if (!this.isVerified()) {
          /**
           * Redirect user to the on-boarding process depending
           * on what they lack
           */
          let route = this.getNeededVerification()
          if (route) {
            if (!route.params) {
              route.params = {}
            }

            route.params.alert = {
              state: false,
              label: 'Please verify your account to proceed...'
            }
            this.$router.replace(route)
          }
        }
      }

      /* ...pages that require verification ID approval */
      if (this.$route.matched.some(route => route.meta.requiresVerifiedId)) {
        if (!this.isIdVerified()) {
          this.$router.push({
            name: 'user.settings-page',
            params: {
              alert: {
                state: false,
                label: 'Please verify your IDs to proceed...'
              }
            }
          })
        }
      }

      /* ...pages that require Stripe payouts enabled */
      if (this.$route.matched.some(route => route.meta.requiresPayout)) {
        if (!this.isPayoutEnabled()) {
          this.$router.push({
            name: 'user.settings-page',
            hash: '#payouts',
            params: {
              alert: {
                state: false,
                label: 'Please add in a payout detail to proceed...'
              }
            }
          })
        }
      }

      this.routeGuardLoading = false
    }
  },
  async created() {
    await this.routeGuardInit()
  }
}
